import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { SUPPLIER_SALES_ANALYTIC_METRIC } from 'modules/dashboard/constant';
import {
  ANALYTIC_ORDER_DPA_METRIC,
  ANALYTIC_SALES_METRIC,
  IAnalyticSalesSummary,
  LOGISTIC_SALES_METRIC,
  SUPPLIER_SALES_METRIC,
} from 'modules/dashboard/interfaces/IAnalyticSummarySales';
import { DC_SALES_METRIC } from 'modules/inventory/distribution-centers/constants/distribution-centers.metric';

class AnalyticSalesService extends EntityApiService<any> {
  searchAnalytic = (metric: ANALYTIC_SALES_METRIC, params?: any, config?: RequestConfig) => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/sales/${metric}`), params, config));
  };

  findOrdersByDPA = (
    metric: ANALYTIC_ORDER_DPA_METRIC,
    service?: 'dc' | 'logistics',
    params?: any,
    config?: any,
  ): Promise<any> => {
    const serviceName = service === 'dc' ? 'dc' : 'logistic';
    if (!service) {
      return this.handleResponse(ApiClientService.post(this.getPath(`/sales/${metric}`), params, config));
    }
    return this.handleResponse(
      ApiClientService.post(this.getPath(`/summary/${service}/${serviceName}-${metric}`), params, config),
    );
  };

  getDistributionCenterAnalytic = (
    metric: DC_SALES_METRIC,
    params?: any,
    config?: RequestConfig,
  ): Promise<IAnalyticSalesSummary> => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/summary/dc/${metric}`), params, config));
  };

  getSupplierAnalytic = (
    metric: SUPPLIER_SALES_METRIC,
    service: 'product' | 'sales' | 'coverage',
    params?: any,
    config?: RequestConfig,
  ): Promise<IAnalyticSalesSummary> => {
    return this.handleResponse(
      ApiClientService.post(`/ms-analytics/api/v1/summary/supplier/${service}/${metric}`, params, config),
    );
  };

  getLogisticAnalytic = (
    metric: LOGISTIC_SALES_METRIC,
    params?: any,
    config?: RequestConfig,
  ): Promise<IAnalyticSalesSummary> => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/summary/logistics/${metric}`), params, config));
  };

  getSupplierSalesAnalytic = (metric: SUPPLIER_SALES_ANALYTIC_METRIC, params?: any, config?: RequestConfig) =>
    this.handleResponse(ApiClientService.post(`/ms-analytics/api/v1/sales/supplier/${metric}`, params, config));
}

export default new AnalyticSalesService('/ms-analytics/api/v1');
